import React from 'react';
import { useSearchParams } from 'react-router-dom';
import StudyWordsPage from './StudyWordsPage';
import BookWordList from '../book/BookWordList';

const StudyWordsSwitcher = () => {
  const [searchParams] = useSearchParams();
  const bookId = searchParams.get('bookId');

  if (bookId) {
    return <BookWordList />;
  }

  return <StudyWordsPage />;
};

export default StudyWordsSwitcher;

